import { useMutation, useQueryClient, UseMutationResult } from "react-query"
import Settings from "utils/CarrotConfig"
import CarrotClient from "lib/carrot-api"
import ResponseError from "utils/ResponseError"
import { getCarrotPlansCacheKey } from "./useCarrotPlans"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

export default function useDeleteTestCarrotPlan(employeeId: number): UseMutationResult<void, ResponseError, void> {
  const queryClient = useQueryClient()

  return useMutation<void, ResponseError, void>(() => client.deleteTestCarrotPlan(employeeId), {
    onSuccess: () => {
      queryClient.invalidateQueries(getCarrotPlansCacheKey(employeeId))
      queryClient.invalidateQueries(["GetEmployee", String(employeeId)])
      queryClient.invalidateQueries(["RoutingInfo", employeeId])
      queryClient.invalidateQueries(["EmployeeSettings", employeeId])
    }
  })
}
